import consumer from './consumer';

export function createTaskChatSubscription(taskId, callbacks) {
  return consumer.subscriptions.create(
    { channel: 'TaskChatChannel', task_id: taskId },
    callbacks
  );
}
